export default function Logo() {
  return <h1>🏝️ Trip Planner 🧳</h1>;
}
